import { createStore, compose, applyMiddleware } from 'redux';
import reducers from './reducers';
import middlewares from './middlewares';

const { routerMiddleware } = middlewares;

export default (history) => (preloadState = {}) => {
  const store = createStore(
    reducers(history),
    preloadState,
    compose(applyMiddleware(routerMiddleware(history)))
  );
  return store;
};
